import { render, staticRenderFns } from "./WorkflowEmailReviewQueue.vue?vue&type=template&id=6f7d8b60"
import script from "./WorkflowEmailReviewQueue.vue?vue&type=script&lang=js"
export * from "./WorkflowEmailReviewQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports